import { Box, useMediaQuery, useTheme } from '@mui/material';
import { createFileRoute, Navigate, Outlet, redirect } from '@tanstack/react-router';
import { Permission, useAuthContext } from '../../../features/auth';
import { EntityManagementPageHeader } from '../../../features/entity-management/components';
import { PERIVERSE_HEADER_HEIGHT_PX } from '../../../shared';

export const Route = createFileRoute('/_auth/entity-management')({
  staticData: {
    title: 'pages.entityManagement.title',
    description: 'pages.entityManagement.description',
  },
  beforeLoad: async ({ context }) => {
    const { useAuthStore } = await import(
      '../../../features/auth/stores/auth.store'
    );

    const authStore = useAuthStore.getState();

    if (authStore.isLoading || !authStore.isInitialized) {
      return;
    }

    if (!authStore.isAuthenticated) {
      throw redirect({ to: '/' });
    }

    if (authStore.isLoading || !authStore.isInitialized) {
      return;
    }

    if (!authStore.hasPermission(Permission.IMPLEMENTATION_ENGINEER)) {
      throw redirect({ to: '/403' });
    }
  },
  component: EntityManagementLayout,
  notFoundComponent: NotFound,
});

function EntityManagementLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box
      sx={{
        marginTop: isDesktop ? `${PERIVERSE_HEADER_HEIGHT_PX}px` : 0,
      }}
    >
      <EntityManagementPageHeader />
      <Outlet />
    </Box>
  );
}

function NotFound() {
  return <Navigate to="/entity-management" replace={true} />;
}
